/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import type { Resource } from 'i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export const i18next = (resources: Resource) => {
  i18n
    .use(LanguageDetector) // detect user language
    .use(initReactI18next)
    .init({
      debug: false,
      fallbackLng: 'en',
      interpolation: { escapeValue: false },
      react: { useSuspense: false },
      resources,
    });

  return i18n;
};
